import { LOGOUT } from '@/utils/store/mutationTypes'
import { FETCH_USER } from '@/utils/store/actionTypes'
import { getCookieDomain } from '@/utils/cookie'
import { IS_AUTHENTICATED, USER_COUNTRY } from '@/utils/store/getterTypes'

export default async function ({ app, store, isHMR, route, redirect, params }) {
  if (isHMR) {
    return
  }

  const basePath = `/${store.state.app.locale}-${store.state.app.country}`

  const token = app.$cookies.get('apollo-token')
  const expires = app.$cookies.get('apollo-expires')

  if (!token || !token.length) {
    if (route.path.includes('account') && !route.path.includes('create-account')) {
      redirect(`${basePath}/login?next=${encodeURIComponent(route.fullPath.replace(`/${route.params.lang}`, ''))}`)
    }

    return
  }

  if (route.path.includes('login')) {
    redirect(`${basePath}/account`)
  }

  const onExpiredSession = () => {
    app.$cookies.remove('apollo-expires', {
      path: '/',
      domain: getCookieDomain()
    })
    app.$cookies.remove('apollo-token', {
      path: '/',
      domain: getCookieDomain()
    })

    store.commit(`auth/${LOGOUT}`)

    redirect(`${basePath}/login?next=${encodeURIComponent(route.fullPath.replace(`/${route.params.lang}`, ''))}`)

    if (process.client) {
      window.$otoaster.warning(app.i18n.t('Notification.ExpiredSession'))
    }
  }

  if (!expires || app.$moment.unix(expires).isBefore(new Date())) {
    onExpiredSession()

    return
  }

  if (!store.state.auth.user) {
    try {
      await store.dispatch(`auth/${FETCH_USER}`)
    } catch (error) {
      onExpiredSession()
    }
  }

  const [locale, country] = params.lang.split('-')

  if (store.getters[`auth/${IS_AUTHENTICATED}`] && country !== store.getters[`auth/${USER_COUNTRY}`]) {
    const slug = route.fullPath.split('/').slice(2).join('/')
    return redirect(`/${locale}-${store.getters[`auth/${USER_COUNTRY}`]}/${slug}`)
  }
}
